<template>
    <div class="agree-form">
        <label :for="`${nameInputAgree}-agree`">
            <input
                type="checkbox"
                :name="`${nameInputAgree}-agree`"
                :id="`${nameInputAgree}-agree`"
                v-model="isAgreeFormSubmit"
            />
            <p>
                Продолжая регистрацию, вы соглашаетесь с
                <a href="Публичная_оферта_ТЮБЕТЕЙ.pdf" target="_blank">публичной офертой</a>,
                <a href="Политика_обработки_персональных_данных.pdf" target="_blank"
                    >политикой обработки персональных данных</a
                >, <a href="Система_лояльности_ТЮБЕТЕЙ.pdf" target="_blank">системой лояльности</a> и даете
                <a href="Согласие_на_обработку_персональных_данных.pdf" target="_blank"
                    >согласие на обработку персональных данных</a
                >
            </p>
        </label>
    </div>
</template>

<script>
export default {
    props: ["nameInputAgree"],
    data() {
        return {
            isAgreeFormSubmit: false,
        };
    },
    watch: {
        isAgreeFormSubmit(value) {
            value ? this.$emit("toAgreeTrue", value) : this.$emit("toAgreeFalse", value);
        },
    },
};
</script>

<style lang="scss" scoped>
.agree-form {
    color: #333;
    font-size: 12px;
    line-height: 15px;
    margin-top: 2rem;
    label {
        display: flex;
        align-items: flex-start;
        cursor: pointer;
    }
    input {
        -webkit-appearance: none;
        -moz-appearance: none;
        display: inline-block;
        min-width: 20px;
        height: 20px;
        margin: 0 10px 0 0;
        padding: 0;
        vertical-align: top;
        outline: none;
        transition: background 0.3s ease;
        background-position: center;
        cursor: pointer;
        border: 1px solid #333;
        border-radius: 5px;
        &:checked {
            background: url("@/assets/img/svg/icon-check.svg") no-repeat;
            background-position: center;
            background-color: var(--green);
            border: 1px solid var(--green);
        }
    }
    a {
        color: inherit;
        text-decoration: underline;
    }
}
</style>
